var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _vm.title
        ? _c(
            "v-toolbar",
            {
              staticClass: "transparent",
              attrs: { dark: Boolean(_vm.color), dense: "", flat: "" },
            },
            [
              _vm.icon
                ? _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ])
                : _vm._e(),
              _c(
                "v-toolbar-title",
                {
                  staticClass:
                    "px-5 subtitle-2 grey-700--text font-weight-medium",
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.color ? _c("v-divider") : _vm._e(),
      _c("v-card-text", {
        staticClass: "py-4 px-5 grey-500--text",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _c("v-divider"),
      _c(
        "v-card-actions",
        { staticClass: "px-5 py-4" },
        [
          _c("v-spacer"),
          _c("v-dialog-actions", { attrs: { actions: _vm.actions, flat: "" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }